// extracted by mini-css-extract-plugin
module.exports = {"subNav":"SubNav_subNav__2JYMM","active":"SubNav_active__2_j6W"};